/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IntakesAndOutputsInactivateAliases {
  FIELD_INTAKES = 'field-intakes',
  FORM_INTAKES_INACTIVATE = 'form-intakes-inactivate',
  LAYOUT_INTAKES_INACTIVATE = 'layout-intakes-inactivate',
  PANEL_INTAKES_INACTIVATE = 'panel-intakes-inactivate',
  TEXT_AREA_INTAKES = 'text-area-intakes',
}
export { IntakesAndOutputsInactivateAliases };
